import React from 'react';
import { useEducationAuth } from '../contexts/EducationAuthContext';
import { Card, CardContent } from './ui/card';
import { getPreview } from '../utils/founderPreview';
import { exitFounderPreview } from './FounderPreviewBanner';

/**
 * AdminGuard — Sprint 38 (Deep QA Pass F remediation).
 *
 * Route-level P0 security guard for /admin/* pages that were previously
 * rendering their full content to unauthenticated users. Uses the existing
 * EducationAuth architecture (role === 'shs_admin'). NO auth architecture
 * redesign.
 *
 * Discovered in testing_agent iteration_149 as leaking:
 *   /admin/revenue, /admin/video-scripts, /admin/campaigns,
 *   /admin/cpap-analytics, /admin/insights, /admin/scoring-mastery/app,
 *   /admin/scoring-mastery/qa
 *
 * Mirrors the "Admin access required." pattern already in use by
 * AdminPillarsPage / AdminHub / AdminEnterprise / etc.
 */
export default function AdminGuard({ children }) {
  const { user } = useEducationAuth();
  const isAdmin = user?.role === 'shs_admin';

  if (getPreview()) {
    return (
      <div className="p-6 max-w-4xl mx-auto" data-testid="admin-guard-preview-blocked">
        <Card>
          <CardContent className="p-6 text-amber-800 space-y-3">
            <p>The Admin Console is blocked during Founder Preview. / La consola de administración está bloqueada durante la Vista previa del Fundador.</p>
            <button type="button" onClick={exitFounderPreview} className="rounded-full bg-slate-900 text-white px-4 py-2 text-sm" data-testid="admin-guard-exit-preview-btn">Exit Preview / Salir</button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="p-6 max-w-4xl mx-auto" data-testid="admin-guard-denied">
        <Card>
          <CardContent className="p-6 text-rose-600">
            Admin access required.
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
